export const ultimateXmenBundle = {
  theBestComicSubscription:
    "The best comic subscription, <1/> now with even more goodies",
  gcAlreadyGivesYouUnlimitedAccess:
    "GlobalComix Gold already gives you unlimited access to 100,000+ comics. <1/> This holiday, we're making the deal even sweeter: Annual subscribers get 10 collectible books from top publishers.",
  getTheUltimateXMenBundle: "Get The Ultimate X-Men Bundle",
  goAnnualForLimitedTime:
    "GlobalComix Gold already gives you unlimited access to 100,000+ comics. Go annual for a limited time and get the X-Men bundle free to keep forever.",
  becomeAGoldMember: "Become a Gold Member and claim your bundle",
  signUpNow: "Sign up Now",
  welcomeToGlobalComix: "Welcome to GlobalComix! ",
  youJustEarned: "You just received 10 free books!",
  yourBundleIsReady: "Your bundle is ready to read in your library.",
  getAYearOfGlobalComix:
    "Get a year of GlobalComix Gold and the first five issues of X-Men Ultimate for just $69.",
  subscribe: "Subscribe $69/yr",
};
